module.exports = __webpack_public_path__ + "b3570f05cb01aa27905210db49f3cc67.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/SpotinTechnical_mobile.svg
// module id = 163
// module chunks = 0